import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function PaymeReturnBridge() {
  const [sp] = useSearchParams();
  const pid = Number(sp.get("pid") || 0);

  useEffect(() => {
    // שולחים ל-parent הודעה: חזרנו מתשלום
    try {
      window.parent.postMessage(JSON.stringify({ type: "payme_return", pid }), window.location.origin);
    } catch (_) {}

    // אופציונלי: נציג “בודקים…” כדי שלא יהיה לבן
  }, [pid]);

  return (
    <div style={{ padding: 16, fontFamily: "Arial", direction: "rtl" }}>
      ✅ התקבל אישור חזרה מהתשלום. בודקים סטטוס…
    </div>
  );
}
